var baseStyle = {
  input: {
    _focus: {
      boxShadow: 'none'
    }
  }
};
export default {
  baseStyle
};
//# sourceMappingURL=Editable.js.map